"use client"
import Script from 'next/script';
import styles from './styles.module.scss';
import { useEffect } from 'react';
const NewsletterForm = props => {
    const {portalId, formId, colorScheme} = props || {};
    useEffect(()=>{
      const loadHubspotForm = () => {
        console.log("loaded");
          if (window?.hbspt) {
            console.log("window present");
              try {
                console.log("trying");
                  window.hbspt.forms.create({
                      region: "na1",
                      portalId: portalId,
                      formId: formId,
                      target: "#newsletterForm"
                  });
              } catch (error) {
                  console.error("Error creating HubSpot form:", error);
              }
          }
      };
      loadHubspotForm();
    }, [])


    return(
      <div className={styles.newsletterForm}>
        <div id="newsletterForm" className={`hsForm ${colorScheme}`}></div>
      </div>

    );
}

export default NewsletterForm;